.remoteSettingsErrorWrapper {
  margin: 24px;
  font-size: 14px;
  
  a {
    text-decoration: none;
    @include themify($themes) {
      color: themed("link_font");
    }
  }
  
  .header {
    margin-bottom: 24px;
    font-size: 16px;
  }
  
  .points {
    margin-top: 6px;
    margin-bottom: 12px;
  }
}
